// 创建全局数据库管理器实例
import { DatabaseManager } from './databaseManager'
export const databaseManager = new DatabaseManager()

// 便捷的初始化函数
export const initializeDatabase = async () => {
  try {
    await databaseManager.fullInitialize()
    return true
  } catch (error) {
    console.error('数据库初始化失败:', error)
    return false
  }
}